import { IExportColumnModel } from "../../../../shared/models";

export const SchemasColumnList: IExportColumnModel[] = [
]